<template>
  <div class="mobile-login-page-div">
    <div class="mobile-login-page-div-header">
      <img class="logo" :src="logo | imgFormat" />
      <!--波浪线-->
      <svg viewBox="0 50 500 35" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
        <path fill="#fff" d="M 0 70 Q 87.5 47, 175 70 T 350 75 T 500 70 V 100 H 0 V 0"></path>
      </svg>
      <!--背景-->
      <div class="ds-login-page-header-bg">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="mobile-login-page-div-body" :style="bodyStyle" v-show="!isTelephoneLogin">
      <div class="login-page-input-content">
        <van-field class="input-content-item" v-model="loginName" :placeholder="usernamePlaceholder" />
        <van-field class="input-content-item input-content-margin" type="password" v-model="password" :placeholder="passwordPlaceholder" />
        <div class="input-content-verify input-content-margin">
          <van-field class="input-content-item" v-model="code" :placeholder="verifyPlaceholder" />
          <img class="input-content-verifyimg" :src="codeUrl" alt="" @click="updateCodeUrl" />
        </div>
      </div>
      <div
        class="login-page-submit-button"
        :class="
          loginName.length == 0 || password.length == 0 || code.length == 0
            ? 'login-page-submit-button-disable'
            : ''
        "
        @click="submitByUsername">
        确定
      </div>
      <div class="login-page-forget-content">
        <div class="login-page-forget-button" v-if="hasForgetPwd" @click="forgetButtonFunction">
          忘记密码?
        </div>
      </div>
      <div class="login-page-exchange-button" v-if="hasPhoneLogin" @click="changeLoginType(true)">
        验证码登录
      </div>
    </div>
    <div class="mobile-login-page-div-body" :style="bodyStyle" v-show="isTelephoneLogin">
      <div class="login-page-input-content login-page-phone-input-content">
        <van-field class="input-content-item" v-model="phoneNumber" type="tel" :placeholder="phonePlaceholder" />
        <van-field class="input-content-item input-content-margin" :disabled="!verifyPhoneNumber()" v-model="phoneCode" :placeholder="phoneVerifyPlaceholder">
          <template #extra>
            <div class="input-content-send-verify" @click="getCode">
              {{ codeBtType != "" ? `${countdownTime}s` : "获取验证码" }}
            </div>
          </template>
        </van-field>
      </div>
      <div
        class="login-page-submit-button"
        :class="
          phoneNumber.length == 0 || phoneCode.length == 0
            ? 'login-page-submit-button-disable'
            : ''
        "
        @click="submitByPhone">
        确定
      </div>
      <div class="login-page-forget-content">
        <div class="login-page-forget-button"></div>
      </div>
      <div class="login-page-exchange-button" @click="changeLoginType(false)">
        账号登录
      </div>
    </div>
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfMobileLoginPage",
  ctrlCaption: "登录",
  mixins: [$mixins.control],
  components: {},
  design: {
    isMask: false,
  },
  data() {
    return {
      logo:
        dsf.config.setting_teas_mob_logo_picture ||
        dsf.url.getWebPath("~/static/img/product/mobile-logo-login.png"),
      tabPositions: [],
      isTelephoneLogin: false,
      tabActive: 0,
      // 获取验证码按钮的状态。countdown：倒计时中
      codeBtType: "",
      // 验证码倒计时总的时间
      countdownTimes: 120,
      // 验证码倒计时的时间
      // 图片验证码
      codeUrl: "",
      countdownTime: 0,
      loginName: "",
      password: "",
      code: "",
      codeId: "",
      phoneNumber: "",
      phoneCode: "",
    };
  },
  props: {
    forgetUrl: {
      type: String,
      default: "/mobile/teas/passwordManager/mobile-forgetPassword",
    },
    hasForgetPwd: {
      type: Boolean,
      default: true,
    },
    hasPhoneLogin: {
      type: Boolean,
      default: true,
    },
    beforeLogin: {
      type: [Function, null],
    },
    usernamePlaceholder: {
      type: String,
      default: "请输入账号",
    },
    passwordPlaceholder: {
      type: String,
      default: "请输入密码",
    },
    verifyPlaceholder: {
      type: String,
      default: "请输入验证码",
    },
    phonePlaceholder: {
      type: String,
      default: "请输入手机号码",
    },
    phoneVerifyPlaceholder: {
      type: String,
      default: "请输入验证码",
    },
  },
  computed: {
    bodyStyle() {
      let res = {};
      if (dsf.config.setting_teas_mob_login_bottom_bg) {
        let src = Vue.filter("imgFormat")(
          dsf.config.setting_teas_mob_login_bottom_bg
        );
        res["background-image"] = `url("${src}")`;
      }
      return res;
    },
  },
  created() {
    this.updateCodeUrl();
  },
  mounted() {
    if (this.isDesign) {
      this.$dispatch("design-height-change", "120%");
    }
  },
  destroyed() {
    clearInterval(this.timeout);
  },
  methods: {
    updateCodeUrl() {
      //更新图片验证码
      this.codeUrl = dsf.url.getWebPath("/code/image?t=",dsf.config.servicePrefix.teas) + new Date().getTime();
    },
    // 获取验证码
    getCode() {
      if (!this.verifyPhoneNumber()) {
        return;
      }
      if (this.codeBtType != "") return;
      if (this.phoneNumber === "") {
        dsf.layer.message("手机号不能为空！", false);
        return;
      }
      if (!dsf.validate("isMobileOrTelPhone", this.phoneNumber)) {
        dsf.layer.message("手机号输入有误", false);
        return;
      }
      let loading = dsf.layer.loading();
      // todo 获取验证码，这次setTimeout模拟了异步请求
      this.loadingIndex = dsf.layer.loading();
      this.$http
        .post("/sms/getCode", {
          phone: this.phoneNumber || "",
        })
        .done(({ success, data, message }) => {
          dsf.layer.closeLoading(this.loadingIndex);
          if (success) {
            dsf.layer.message("发送成功", true);
            this.codeId = data || "";
            this.codeBtType = "countdown";
            this.doCountdown();
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          dsf.layer.closeLoading(this.loadingIndex);
          dsf.layer.message(err.message || "请求异常", false);
        });
    },
    // 执行倒计时
    doCountdown() {
      this.countdownTime = this.countdownTimes - 1;
      this.timeout = setInterval(() => {
        this.countdownTime--;
        if (this.countdownTime <= -1) {
          this.codeBtType = "";
          clearInterval(this.timeout);
        }
      }, 1000);
    },
    // 账号登录
    submitByUsername() {
      if (this.loginName.length == 0 || this.password.length == 0 || this.code.length == 0) {
        return;
      }
      if (this.loginName === "") {
        dsf.layer.message("账号不能为空！", false);
        return;
      }
      if (this.password === "") {
        dsf.layer.message("密码不能为空！", false);
        return;
      }
      if (this.code === "") {
        dsf.layer.message("验证码不能为空！", false);
        return;
      }
      //   if (this.code === "") {
      //     dsf.layer.message("验证码不能为空！", false);
      //     return;
      //   }
      this.loginByUsername(false);
    },
    loginByUsername(isPhone) {
      if (this.beforeLogin) {
        let tempParams = {};
        if (isPhone) {
          tempParams = {
            loginName: this.phoneNumber,
            notdId: this.codeId,
            notdCode: this.phoneCode,
            loginType: 6,
            code: dsf.config.setting_teas_login_super_captcha || "",
          };
        } else {
          tempParams = {
            loginName: this.loginName,
            password: this.password,
            code: this.code,
            loginType: 10,
          };
        }
        return this.beforeLogin(tempParams);
      }
      let loading = dsf.layer.loading();
      let params = {};
      if (isPhone) {
        params = {
          loginName: this.phoneNumber,
          notdId: this.codeId,
          notdCode: this.phoneCode,
          loginType: 6,
          code: dsf.config.setting_teas_login_super_captcha || "",
        };
      } else {
        params = {
          loginName: this.loginName,
          password: dsf.md5(dsf.md5(this.password)),
          code: this.code,
          loginType: 10,
        };
      }
      this.$http
        .post("/CommonLogin/userLogin", params)
        .done(({ success, message, data }) => {
          if (success) {
            this.setStateIsLogin(data);
          } else {
            this.updateCodeUrl();
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          this.updateCodeUrl();
          if (err) {
            dsf.layer.message(err.message || "未知错误", false);
          }
        })
        .finally(() => {
          dsf.layer.closeLoading(loading);
        });
    },
    // 手机号登录
    submitByPhone() {
      if (this.phoneNumber.length == 0 || this.phoneCode.length == 0) {
        return;
      }
      if (this.phoneNumber === "") {
        dsf.layer.message("手机号不能为空！", false);
        return;
      }
      if (!dsf.validate("isMobileOrTelPhone", this.phoneNumber)) {
        dsf.layer.message("手机号输入有误", false);
        return;
      }
      if (this.phoneCode === "") {
        dsf.layer.message("验证码不能为空！", false);
        return;
      }
      this.loginByUsername(true);
    },
    // 判断学员是否需要阅读承诺书
    studentClassNotice() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("teas/mobile/commitment/alert", {})
          .done(function (res) {
            if (res.success) {
              sessionStorage.setItem("needPromise", res.data);
            }
            resolve();
          })
          .error(function (err) {
            dsf.layer.message(err.message || "出错了，请重试", false);
            reject();
          })
          .always(function () { });
      });
    },
    // 储存cookie登录状态
    async setStateIsLogin(data) {
      //通过后端返回的appId进入不同的app
      let groupGo = data.groupGo;
      let appId = this.$root.getAppId();
      let isStudent = dsf.getCookie("userGroupCode") == "001" ? 1 : 0;
      dsf.storage.local.set("logined", true, true);
      dsf.storage.local.set("userType", isStudent, true);
      let toUrl = "";
      let exportUrl = "";
      let from = this.$route.query.from;
      if (groupGo) {
        let urlInfo = dsf.url.parse(groupGo);
        if (urlInfo.searchQuery["appid"]) {
          appId = urlInfo.searchQuery["appid"];
          delete urlInfo.searchQuery["appid"];
        }
        if (urlInfo.searchQuery["url"]) {
          exportUrl = urlInfo.searchQuery["url"];
          delete urlInfo.searchQuery["url"];
        }
        let orName = urlInfo.protocol ? urlInfo.origin : urlInfo.hostname;
        // 连接符
        let connector = dsf.isEmptyObject(urlInfo.searchQuery) ? '' : "?";
        let query = JSON.parse(JSON.stringify(urlInfo.searchQuery));
        if (query.appid) delete query.appid;
        let queryString =  dsf.url.queryStringStringify(query);
        toUrl = orName + urlInfo.pathname + connector + queryString + urlInfo.hash;
      } else {
        toUrl = "";
      }
      await this.$root.initApp(appId);
      //   if (isStudent === 1) {
      //     await this.studentClassNotice();
      //   }
      let toPage = () => {
        if (exportUrl.length > 0) {
          exportUrl = decodeURIComponent(exportUrl);
          let tempUrl = window.location.pathname;
          tempUrl += "#" + exportUrl;
          location.replace(tempUrl);
        } else {
          if (from) {
            toUrl = decodeURIComponent(from);
          } else {
            if (!toUrl) {
              //获取当前页面地址
              toUrl = window.location.pathname;
              if (window.location.search) {
                toUrl += window.location.search;
              }
            }
            let toUrlInfo = dsf.url.parse(toUrl);
            if (!toUrlInfo.hash) {
              console.log(this.$root.navs[0].href);
              toUrl += "#" + this.$root.navs[0].href;
            }
            location.replace(toUrl);
          }
        }
      };

      // app端
      if (!dsf.client.weixin() && window.$sharedPreferences) {
        $sharedPreferences.save(
          {
            userId: dsf.cookies.get("app_auto_login_key"),
            loginName: this.loginName,
            password: "",
          },
          toPage,
          function (e) {
            toPage();
          }
        );
      } else {
        toPage();
      }
    },
    changeLoginType(loginType) {
      this.isTelephoneLogin = loginType;
    },
    forgetButtonFunction() {
      console.log(this.forgetUrl);
      this.$router.push({
        path: this.forgetUrl,
      });
    },
    verifyPhoneNumber() {
      if (dsf.validate("isMobileOrTelPhone", this.phoneNumber)) {
        return true;
      } else {
        return false;
      }
    },
  },
});
</script>